// What the notification prompt remembers on this device. Storage can throw
// (private mode, blocked site data), so every read and write is guarded and
// the prompt carries on with the defaults.
// One entry per person, so a shared family device prompts each of them
const keyFor = (userId) => `notificationPrompt:${userId}`;

export const SHEET_LIMIT = 2;
export const HIDE_DAYS = 30;

const defaults = () => ({
  sheetDismissals: 0,
  hiddenUntil: null,
  iosOld: false,
  afterFirstBookingShown: false,
});

export function read(userId) {
  try {
    const raw = JSON.parse(window.localStorage.getItem(keyFor(userId)) || 'null');
    if (!raw || typeof raw !== 'object') return defaults();
    return {
      sheetDismissals: Number.isFinite(raw.sheetDismissals) ? raw.sheetDismissals : 0,
      hiddenUntil: Number.isFinite(raw.hiddenUntil) ? raw.hiddenUntil : null,
      iosOld: raw.iosOld === true,
      afterFirstBookingShown: raw.afterFirstBookingShown === true,
    };
  } catch (e) {
    return defaults();
  }
}

export function write(userId, patch) {
  try {
    window.localStorage.setItem(keyFor(userId), JSON.stringify({ ...read(userId), ...patch }));
  } catch (e) {
    // Nothing to do: the prompt just won't remember
  }
}

const promptState = { read, write, SHEET_LIMIT, HIDE_DAYS };
export default promptState;
